import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ward-neefs")({
  head: () => buildRouteHead("/ward-neefs", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/board-of-advisors", replace: true });
  },
});
